import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Form, Row, Col } from 'react-bootstrap';

const RegistrationForm = ({ hasLabel }) => {
  // State
  const [formData, setFormData] = useState({
    uname: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    title: '',
    company: '',
    werks: '',
    isAccepted: false
  });

  const navigate = useNavigate(); // useNavigate hook'u kullanarak yönlendirme işlemi yapılacak

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();

    // Sunucuya POST isteği gönder
    try {
      const requestData = {
        ...formData, 
        process: '100019313'
      };
      console.log(requestData)
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      console.log(data);

      if (response.ok && data.responsecode === 0) {
        // Başarılı kayıt popup
        toast.success('Kayıt isteği başarılı bir şekilde oluşturuldu. Kayıt sonucu mail olarak tarafınıza iletilecektir.', {
          theme: 'colored',
          autoClose: 3000, // Popup 3 saniye sonra otomatik kapanacak
          onClose: () => navigate('/authentication/split/login') // Popup kapandığında login sayfasına yönlendirme yapılacak
        });
      } else {
        console.error('Failed to submit form');
        toast.error('Kayıt işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Kayıt işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Ad Soyad</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Ad Soyad' : ''}
          value={formData.uname}
          name="uname"
          onChange={handleFieldChange}
          type="text"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email adresi</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Email adresi' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Telefon Numarası</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Telefon Numarası' : ''}
          value={formData.phone}
          name="phone"
          onChange={handleFieldChange}
          type="text"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Ünvan</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Ünvan' : ''}
          value={formData.title}
          name="title"
          onChange={handleFieldChange}
          type="text"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Kurum Ünvanı</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Çalıştığı Kurum' : ''}
          value={formData.company}
          name="company"
          onChange={handleFieldChange}
          type="text"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Firmanın Hangi Tesisi</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Firmanın Hangi Tesisi' : ''}
          value={formData.werks}
          name="werks"
          onChange={handleFieldChange}
          type="text"
        />
      </Form.Group>

      <Row className="g-2 mb-3">
        <Form.Group as={Col} sm={6}>
          {hasLabel && <Form.Label>Şifre</Form.Label>}
          <Form.Control
            placeholder={!hasLabel ? 'Şifre' : ''}
            value={formData.password}
            name="password"
            onChange={handleFieldChange}
            type="password"
          />
        </Form.Group>
        <Form.Group as={Col} sm={6}>
          {hasLabel && <Form.Label>Şifreyi Onayla</Form.Label>}
          <Form.Control
            placeholder={!hasLabel ? 'Şifreyi Onayla' : ''}
            value={formData.confirmPassword}
            name="confirmPassword"
            onChange={handleFieldChange}
            type="password"
          />
        </Form.Group>
      </Row>

      <Form.Group className="mb-3">
        <Form.Check type="checkbox" id="acceptCheckbox" className="form-check">
          <Form.Check.Input
            type="checkbox"
            name="isAccepted"
            checked={formData.isAccepted}
            onChange={e =>
              setFormData({
                ...formData,
                isAccepted: e.target.checked
              })
            }
          />
          <Form.Check.Label className="form-label">
            Kullanım şartlarını ve{' '}
            <Link to="#!">gizlilik politikasını</Link> kabul ediyorum.
          </Form.Check.Label>
        </Form.Check>
      </Form.Group>

      <Form.Group className="mb-4">
        <Button
          className="w-100"
          type="submit"
          disabled={
            !formData.uname ||
            !formData.email ||
            !formData.password ||
            !formData.confirmPassword ||
            !formData.isAccepted
          }
        >
          Kayıt Ol
        </Button>
      </Form.Group>
    </Form>
  );
};

RegistrationForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default RegistrationForm;
